if (!customElements.get('formthr-protein-comparison')) {
  customElements.define('formthr-protein-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const select = this.querySelector('select');
      if (!select) return;
      this.classList.add('is-enhanced');
      this.querySelector('.formthr-compare__controls').hidden = false;
      this.dataset.selected = select.value;
      select.addEventListener('change', () => { this.dataset.selected = select.value; });
    }
  });
}
